import { render, staticRenderFns } from "./BaseButtonSchemaHeader.vue?vue&type=template&id=70965ae8&scoped=true&"
import script from "./BaseButtonSchemaHeader.vue?vue&type=script&lang=js&"
export * from "./BaseButtonSchemaHeader.vue?vue&type=script&lang=js&"
import style0 from "./BaseButtonSchemaHeader.vue?vue&type=style&index=0&id=70965ae8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70965ae8",
  null
  
)

export default component.exports